(function() {
    'use strict';
    angular
        .module('app')
        .component('headerComponent',
        {
            templateUrl: 'assets/header/header-component.html',
            controller: headerController
        });

    headerController.$inject = ['$sessionStorage', '$location', 'authService'];
    function headerController($sessionStorage, $location, authService) {
        var ctrl = this;
        ctrl.app = $sessionStorage;
        ctrl.isHistoryEnabled = function () {
            return $sessionStorage.logonInfo
                && $sessionStorage.logonInfo.security
                && $sessionStorage.logonInfo.security.hasAdminRole;
        };
        ctrl.logout = function () {
            authService.logout();
            $sessionStorage.logonInfo = {};
            $location.path('/');
        };
        ctrl.login = function () {
            authService.logout();
            $location.path('/login');
        }
    }
})();


// WEBPACK FOOTER //
// ./src/header/header.component.js